// extracted by css-extract-rspack-plugin
export default {"collectionRow":"juY48"};